import { API } from '@utils/axios'

export async function fetchDepositList (params: any) {
  const response = await API.get('/DepositManagement/StoreDepositList', { params })
  return response.data
}

export async function addDeposit (data: any) {
  const response = await API.post('/DepositManagement/AddDeposit', data)
  return response.data
}

export async function downloadDepositList (params: any) {
  const response = await API.get('/DepositManagement/DownloadStoreDepositFile', { params, responseType: 'blob' })
  return response.data
}

export async function importDepositList (data: any) {
  const response = await API.post('/DepositManagement/UploadAddDepositFile', data, { headers: { 'Content-Type': 'multipart/form-data' }, responseType: 'blob' })
  return response.data
}

export async function fetchHistory (params: any) {
  const response = await API.get('/DepositManagement/HistoryList', { params })
  return response.data
}

export async function downloadHistory (params: any) {
  const response = await API.get('/DepositManagement/DownloadHistoryFile', { params, responseType: 'blob' })
  return response.data
}
